import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { clientsService } from '../api/clients.service';
import { CLIENTS_KEYS } from './queryKeys';
import type { Client } from '../types';

export function useClient(clientId: string): Client | undefined {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  const { data } = useQuery({
    queryKey: CLIENTS_KEYS.detail(orgId, clientId),
    queryFn: ({ signal }) => clientsService.getById(clientId, signal),
    staleTime: 60_000,
    enabled: !!orgId && !!clientId,
  });

  return data;
}
